import { yup } from '@dis/form'

export const getSelectAtlasValidationSchemaPart = () => ({
  atlasId: yup.number().required(),
  folderId: yup.number().optional(),
})
